<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window copy-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-content">
                <div class="dialog-wrapper">
                    <h5 class="title dialog-title"></h5>

                    <div class="msg-view">
                        <p>{{ shareTxt }}</p>
                    </div>

                    <div class="u-btn copy" @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
                </div> 
            </div>     
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,       
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.copy-modal{
    width: 667px;
    height: 378px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.title{
    width: 429px;
    height: 64px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/modal/title-invite.png);  
}

.msg-view{
    margin: 0 auto 30px;
    padding: 0 20px;
    color: #cbbda5;
    font-size: 24px;
    text-align: center;
}

.u-btn.copy{
    width: 230px;
    height: 76px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/btn-copy.png);
} 

.notice{
    margin-top: 20px;
    text-align: center;
    color: #c6d0df;
}
</style>